import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { MSALConstants } from '../constants/msal';

function useApiAuthorization () {
    const { instance, accounts } = useMsal();

    const getTokenRequest = () => {
        const authority = accounts.length > 0
            ? MSALConstants.AUTH.CONFIGURATION.BASE_AUTHORITY + accounts[0].idTokenClaims.tfp
            : null;

        let request = {
            //TODO: Move scopes out
            scopes: ['https://BuildEB2C.onmicrosoft.com/buildeapidev/Builde.read'],
            account: accounts.length > 0 ? accounts[0] : null
        }

        if (authority) {
            request.authority = authority;
        }

        return request;
    }

    const requestToken = (silent = true) => {
        return silent 
            ? instance.acquireTokenSilent(getTokenRequest())
            : instance.acquireTokenPopup(getTokenRequest());
    }

    const getAccessToken = async (silent = true) => {
        let accessToken = null;

        try {
            const tokenData = await requestToken(silent);
            accessToken = tokenData?.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                const tokenData = await requestToken(false);
                accessToken = tokenData?.accessToken;
            }
        }

        return accessToken;
    }

    return {
        getAccessToken
    };
}

export default useApiAuthorization;